<template>
  <v-form class="mx-10 mb-10 pa-10 text-center">
    <h3 class="text-left mb-5 text-primary">Create Credential</h3>
    <v-layout>
      <v-row>
        <v-col cols="12">
          <h4 class="text-start mb-5">Second factors:</h4>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-checkbox
            class="mt-0 pt-0"
            v-model="enabledPIN"
            label="PIN"
            background-color="white"
          ></v-checkbox>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-checkbox
            class="mt-0 pt-0"
            v-model="enabledOTP"
            label="OTP"
            background-color="white"
          ></v-checkbox>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-checkbox
            class="mt-0 pt-0"
            v-model="enabledSMS"
            label="SMS"
            background-color="white"
          ></v-checkbox>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-checkbox
            class="mt-0 pt-0"
            v-model="enabledEmail"
            label="Email"
            background-color="white"
          ></v-checkbox>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-checkbox
            class="mt-0 pt-0"
            v-model="enabledWebAuthn"
            label="WebAuthn"
            background-color="white"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-text-field
            background-color="rgba(255,255,255)"
            v-model="multisign"
            label="Multisign"
            type="number"
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-col cols="1">
            <v-btn
              color="primary"
              @click="createCredential"
              style="color:white"
              :disabled="multisign == '' || !(enabledEmail || enabledOTP || enabledPIN || enabledSMS || enabledWebAuthn)">
              Create
            </v-btn>
          </v-col>
        </v-col>
      </v-row>

    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import alisonServer from  '../services/alisonServer.js';
  export default {
    props:["data", "config", "serverConfig"],
    data: () => ({
      multisign: '15',
      enabledPIN: false,
      enabledOTP: false,
      enabledSMS: false,
      enabledEmail: false,
      enabledWebAuthn: false,
    }),
    mounted(){
    },
    watch:{

    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async createCredential() {
        if (this.serverConfig === null || this.serverConfig.generationAccessToken === undefined) {
          this.setColor('error');
          this.setSnack('Missing generation token');
          return;
        }
        const seatId = this.serverConfig.seatId;
        const credentialData = {
          multisign: this.multisign,
          webauthn: this.enabledWebAuthn,
          pin: this.enabledPIN,
          sms: this.enabledSMS,
          email: this.enabledEmail,
          otp: this.enabledOTP,
        };
        try {
          const credentialId = await alisonServer.createCredential(seatId, credentialData);
          this.$emit("setServerConfig", {
            credential: {
              id: credentialId,
              ...credentialData,
            },
          })
          this.setColor('success');
          this.setSnack('Credential ' + credentialId + " generated");
        } catch (e) {
          this.setColor('error');
          this.setSnack(e);
          console.log(e);
        }
      }
    },
  }
</script>
